import { Directive, ElementRef, HostListener } from "@angular/core";
@Directive({
    selector:'[InputNumberOnly]'
})
export class InputNumberOnlyDirective {

    private readonly regex: RegExp = new RegExp(/^[0-9]*$/g);
    constructor(private el: ElementRef) {}
    @HostListener('keydown',['$event'])
    onkeyDown(event: KeyboardEvent){
        if(event.key === 'Backspace' || event.key === 'Delete' || event.key ==='ArrowLeft' || event.key == 'ArrowRight'){
            return;
        }
        if(event.key.match(this.regex) === null) {
            event.preventDefault();
        }
    }
}
